import { apiRequest, Chat } from "@vojomo-core/shared";
import { IoInformationCircleOutline } from "react-icons/io5";
import styles from "./Modus.module.css";
import { useState } from "react";
import { Modal } from "antd";

export function Modus(): React.ReactElement {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div>
      <h3 className="mb-0 pb-0 text-center">Talk with Vo</h3>
      <div className={styles.betaAlert}>
        <div className="flex justify-between">
          <p className="font-bold mt-0 mb-2 text-lg">VoChat Beta</p>
          <IoInformationCircleOutline
            style={{ cursor: "pointer" }}
            size={14}
            onClick={() => {
              setShowInfo(!showInfo);
            }}
          />
        </div>
        <p className="mt-0 mb-2">
          Currently a streamlined AI assistant for drafting and quick questions.
        </p>
        <p className="my-0">
          <span className="font-bold" style={{ color: "#2c1561" }}>
            Coming Soon
          </span>
          : Web search, conversation history, and integration with your Vojomo
          workspace, transforming Vo into your team's AI advisor who understands
          your strategy and context.
        </p>
      </div>
      <div className={styles.modusContainer}>
        <Chat
          agent="VoPersonalAssistant"
          showTranscriptIcon={true}
          showNewConversationButton={true}
        />
      </div>
      <Modal open={showInfo} onCancel={() => setShowInfo(false)} footer={null}>
        <div className="p-4">
          <p className="font-bold">Welcome to VoChat - Early Beta</p>
          <p>
            You're chatting with Vo, Vojomo's Beta AI assistant. In this early
            version, VoChat works great for quick questions, drafting, and
            brainstorming—but it's intentionally limited right now.
          </p>
          <p>
            <strong>What's not available yet</strong>:
            <ul style={{ margin: "5px", padding: "0 20px" }}>
              <li>Real-time web search Memory of previous conversations</li>
              <li>Access to your Vojomo documents and roadmaps</li>
              <li>
                VoChat creating new documents (go{" "}
                <a
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontWeight: "bold"
                  }}
                  onClick={async () => {
                    const topicId = await apiRequest({
                      subRoute: "ai",
                      path: "/setup_new_topic"
                    });

                    window.open(`/documents/docs/${topicId}`, "_blank");
                  }}
                >
                  here
                </a>{" "}
                for document creation)
              </li>
            </ul>
          </p>
          <p>
            <strong>The good news?</strong> These features are coming soon, and
            they'll transform VoChat into a truly powerful workspace companion
            that knows your team's context and strategy.{" "}
          </p>
          <p>
            For now, think of this as Vo getting to know you. We'd love your
            feedback on what you'd like to see first!
          </p>
        </div>
      </Modal>
    </div>
  );
}
